module.exports = __webpack_public_path__ + "img/it_seguroportatil.a274ba44.svg";